// Judge.me Review Button Handler

document.addEventListener('DOMContentLoaded', function () {
  const writeReviewBtn = document.querySelector('.jdgm-no-reviews-fallback .jdgm-write-rev-link')

  if (writeReviewBtn) {
    writeReviewBtn.addEventListener('click', function (e) {
      e.preventDefault()

      // Try multiple methods to open Judge.me review form

      // Method 1: Check if jdgm object exists and has createReview
      if (typeof jdgm !== 'undefined' && jdgm.createReview) {
        const productId = this.getAttribute('data-product-id')
        const productHandle = this.getAttribute('data-product-handle')
        const productTitle = this.getAttribute('data-product-title')
        jdgm.createReview(productId, productHandle, productTitle)
        return
      }

      // Method 2: Try to click on Judge.me's write review button if it exists
      const jdgmWriteBtn = document.querySelector(
        '.jdgm-write-rev-link:not(.jdgm-no-reviews-fallback .jdgm-write-rev-link)'
      )
      if (jdgmWriteBtn) {
        jdgmWriteBtn.click()
        return
      }

      // Method 3: Scroll to review widget and wait for Judge.me to load
      const reviewWidget = document.getElementById('judgeme_product_reviews')
      if (reviewWidget) {
        reviewWidget.scrollIntoView({ behavior: 'smooth' })

        // Wait for Judge.me to initialize and try again
        setTimeout(function () {
          if (typeof jdgm !== 'undefined' && jdgm.createReview) {
            const productId = writeReviewBtn.getAttribute('data-product-id')
            const productHandle = writeReviewBtn.getAttribute('data-product-handle')
            const productTitle = writeReviewBtn.getAttribute('data-product-title')
            jdgm.createReview(productId, productHandle, productTitle)
          }
        }, 1000)
      }
    })
  }

  // Also handle the preview badge click if no reviews
  const previewBadge = document.querySelector('.jdgm-preview-badge a[href="#judgeme_product_reviews"]')
  if (previewBadge) {
    previewBadge.addEventListener('click', function (e) {
      e.preventDefault()
      const reviewWidget = document.getElementById('judgeme_product_reviews')
      if (reviewWidget) {
        reviewWidget.scrollIntoView({ behavior: 'smooth' })
      }
    })
  }
})

// Alternative: Listen for Judge.me to fully load
if (typeof jdgm !== 'undefined') {
  jdgm.on = jdgm.on || function () {}
  jdgm.on('ready', function () {
    console.log('Judge.me is ready')
  })
}
